interface CTAProps {
  title: string;
  description: string;
  subDescription: string;
  ctaLabel: string;
  ctaUrl: string;
  bgImage: string;
}

export default function CTASection({ title, description, subDescription, ctaLabel, ctaUrl, bgImage }: CTAProps) {
  return (
    <section className="relative w-full py-24 md:py-32 overflow-hidden">
      <img
        src={bgImage}
        alt={title}
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-r from-black/70 via-black/50 to-black/40"></div>

      <div className="relative z-10 mx-auto px-4 md:px-6 max-w-6xl">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 items-center">
          <div>
            <h2 className="font-heading text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-4 leading-tight">
              {title}
            </h2>
            <p className="text-white/90 text-base md:text-lg mb-2 font-medium">
              {description}
            </p>
          </div>
          <div className="lg:pl-8">
            <p className="text-white/70 text-sm md:text-base leading-relaxed mb-6">
              {subDescription}
            </p>
            <a
              href={ctaUrl}
              target="_blank"
              rel="nofollow noreferrer"
              className="inline-flex items-center gap-3 px-7 py-3.5 bg-white text-foreground-900 font-semibold rounded-full text-sm hover:bg-foreground-50 transition-all cursor-pointer whitespace-nowrap group"
            >
              <span>{ctaLabel}</span>
              <span className="w-7 h-7 rounded-full bg-foreground-900 flex items-center justify-center group-hover:bg-primary-500 transition-colors">
                <i className="ri-arrow-right-line text-white text-xs"></i>
              </span>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}